import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { showLEWarningSelector } from '../../../../../../redux/cart/cart.selectors';
import { LEWarning as LEWarningComponent } from './le-warning';
const mapStateToProps = createStructuredSelector({
  show: showLEWarningSelector
});
export const LEWarning = connect(mapStateToProps)(LEWarningComponent);